import React from 'react';

const Badge = ({ children, type = "success" }) => {
  const colors = {
    success: "bg-emerald-500/20 text-emerald-400 border-emerald-500/50",
    warning: "bg-amber-500/20 text-amber-400 border-amber-500/50",
    danger: "bg-rose-500/20 text-rose-400 border-rose-500/50",
    info: "bg-cyan-500/20 text-cyan-400 border-cyan-500/50",
  };
  return (
    <span className={`px-3 py-1 rounded-full text-sm font-medium border ${colors[type]}`}>
      {children}
    </span>
  );
};

export default Badge;
